module.exports = "/_next/static/images/dd39d67964068f9dab1ff17126934cb7-girl-holding-card-landing@md.jpg";